export default "__VITE_ASSET___mQI7AyA__"